import { render, staticRenderFns } from "./FormLiming.vue?vue&type=template&id=4ceff206&scoped=true&"
import script from "./FormLiming.vue?vue&type=script&lang=js&"
export * from "./FormLiming.vue?vue&type=script&lang=js&"
import style0 from "./FormLiming.vue?vue&type=style&index=0&id=4ceff206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceff206",
  null
  
)

export default component.exports